import { useMemo, useState } from 'react'

import useCurrentApp from './useCurrentApp'

type User = {
  id: string
  email: string
  firstName: string
  lastName: string
  imageUrl: string
}

/** This hook returns the internal user object by provided ID. */
const useActor = (id: string, appId: string): User | undefined => {
  const { members } = useCurrentApp(appId)
  const [actor, setActor] = useState<User | undefined>()

  useMemo(() => {
    if (id && !actor) {
      const actor = (members as { id: string }[])?.find(
        (member) => member.id === id,
      )
      if (actor) {
        setActor(actor as User)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, members])

  return actor
}

export default useActor
